import React from 'react';
import styled from 'styled-components';
import CommonDialog from 'ls-common-client/dist/components/Dialog';
import DialogHeader from 'ls-common-client/dist/components/DialogHeader';
import Container from 'ls-common-client/dist/components/Container';
import Text from 'ls-common-client/dist/components/Text';
import Icon from 'ls-common-client/dist/components/Icon';
import EmptyButton from 'ls-common-client/dist/components/EmptyButton';

const StyledDialogHeader = styled(DialogHeader)`
  padding: 14px 15px;
  align-items: flex-start;
  min-height: initial;
`;

const StyledCloseIcon = styled(Icon)`
  position: relative;
  top: -8px;
  right: -8px;
`;

const defaultRender = data => {
  const { header, children, onClose } = data;
  return (
    <React.Fragment>
      {typeof header === 'string' ? (
        <StyledDialogHeader>
          <Text width="120px" flex="1 0 auto">
            {!!header && (
              <Text
                color="normal"
                fontWeight="600"
                fontSize="24px"
                display="block"
              >
                {header}
              </Text>
            )}
          </Text>
          <EmptyButton
            onClick={() => onClose()}
            display="flex"
            alignItems="center"
            overflow="hidden"
          >
            <StyledCloseIcon
              color="normal"
              width="43px"
              iconSize="50px"
              className="ls-icon icon-generalxlarge"
            />
          </EmptyButton>
        </StyledDialogHeader>
      ) : (
        header
      )}
      <Container flex="0 1 100%">{children}</Container>
    </React.Fragment>
  );
};

const Dialog = ({ ...props }) => {
  return (
    <CommonDialog
      render={defaultRender}
      {...{
        zIndex: '999999',
        mode: 'desktop',
        maxWidth: '500px',
        border: 'none',
        header: <></>,
        animationDuration: 300,
      }}
      {...props}
    />
  );
};

export default Dialog;
